module.exports = __webpack_public_path__ + "img/plus.a0d090a0.svg";